import React from "react";
import clsx from "clsx";
import { useComplianceInfo } from "hooks/useComplianceInfo";
import { useTranslation } from "react-i18next";
import { ProductHealthCheckedStatusEnum } from "api-client";
import useFeatureFlag from "hooks/useFeatureFlag";

const ProductChips = (props: {
  refUnit?: string;
  conformity?: string[] | null;
  certifications?: string[] | null;
  healthChecked?: ProductHealthCheckedStatusEnum | null;
  hideIfEmpty?: boolean;
  hideCertifications?: boolean;
  containerClassName?: string;
  organisationName?: string | null;
  createdByEmail?: string | null;
}) => {
  const { t } = useTranslation();
  const { getCertificationChipsGroup, getConformityChipsGroup } =
    useComplianceInfo();
  const { isFeatureVisible } = useFeatureFlag();

  const hideChips =
    props.conformity?.length === 0 &&
    props.certifications?.length === 0 &&
    props.hideIfEmpty;

  return (
    <div
      className={clsx(
        "flex mt-[5px] flex-wrap gap-y-1",
        props.containerClassName
      )}
    >
      {isFeatureVisible("new_product_search") && props.organisationName && (
        <div
          className={clsx(
            "text-xs rounded-full px-2 mr-1 whitespace-nowrap flex items-center",
            "bg-indigo-100 text-indigo-700 h-[17px] font-medium"
          )}
        >
          {props.organisationName}
        </div>
      )}

      {props.refUnit && (
        <div
          className={clsx(
            "text-xs rounded-full px-2 mr-1 whitespace-nowrap flex items-center",
            "bg-indigo-100 text-indigo-700 h-[17px] font-medium"
          )}
        >
          {props.refUnit}
        </div>
      )}

      {!hideChips && (
        <>
          {getConformityChipsGroup(props.conformity)}
          {!props.hideCertifications &&
            getCertificationChipsGroup(props.certifications)}
        </>
      )}
      {props.createdByEmail && (
        <div
          className={clsx(
            "text-xs rounded-full px-2 mr-1 whitespace-nowrap flex items-center",
            "bg-indigo-100 text-indigo-700 h-[17px] font-medium"
          )}
        >
          {props.createdByEmail}
        </div>
      )}
      {props.healthChecked &&
        props.healthChecked !== ProductHealthCheckedStatusEnum.None && (
          <div
            className={clsx(
              "text-xs rounded-full h-[17px] px-2 mr-1 whitespace-nowrap bg-indigo-100 text-indigo-700",
              "font-medium flex items-center"
            )}
          >
            {props.healthChecked === ProductHealthCheckedStatusEnum.Full
              ? t("productEditor.healthChecked")
              : t("productEditor.healthCheckedPartial")}
          </div>
        )}
    </div>
  );
};

export default ProductChips;
